import {NonEmbeddedPendingComponent} from "~/components/routerHelpers/nonEmbeddedPendingComponent";
import {Route} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/meta-dashboard/route";

export function PendingComponent() {
    return (
        <NonEmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
            //
        />
    );
}
